module.exports = __webpack_public_path__ + "static/media/Incorrect inclination of the tooth5.c0c8bfa3.png";